import React, { useState } from "react";
import { X, Lock, ShieldCheck, Sparkles } from "lucide-react";
import { startCheckout } from "@/lib/payments";
import { toast } from "sonner";

export default function PaywallModal({ open, onClose, reason = "Descarga y compartir", plan = "basic" }) {
  const [loading, setLoading] = useState(false);
  if (!open) return null;

  const isPremium = plan === "premium";
  const price = isPremium ? 50 : 25;
  const title = isPremium ? "Pack Chingón Premium" : "Pase Chingón";
  const features = isPremium
    ? [
        "3 estilos EXCLUSIVOS: Vintage '86, Lucha Libre, Holográfico",
        "Incluye descarga y compartir permanente",
        "Frames premium con acabado foil",
        "Todos tus stickers, para siempre",
      ]
    : [
        "Descarga ilimitada de stickers",
        "Compartir a WhatsApp, IG, Twitter",
        "Acceso a la galería completa",
        "Pase permanente en este dispositivo",
      ];

  const onPay = async () => {
    setLoading(true);
    try {
      const { init_point } = await startCheckout(plan);
      if (!init_point) throw new Error("no init_point");
      window.location.href = init_point;
    } catch (e) {
      toast.error("No se pudo iniciar el pago. Intenta de nuevo.");
      setLoading(false);
    }
  };

  return (
    <div
      className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black/50"
      data-testid="paywall-modal"
    >
      <div className="w-full max-w-md bg-white border-[4px] border-black shadow-[8px_8px_0_0_#000] p-6 relative">
        <button
          onClick={onClose}
          className="absolute top-3 right-3 w-9 h-9 border-[3px] border-black bg-white shadow-[3px_3px_0_0_#000] nb-btn flex items-center justify-center"
          aria-label="Cerrar"
          data-testid="paywall-close-btn"
        >
          <X strokeWidth={3} className="w-5 h-5" />
        </button>

        <div className={`inline-flex items-center gap-2 border-[3px] border-black shadow-[3px_3px_0_0_#000] px-3 py-1 rotate-[-2deg] ${isPremium ? "bg-[#CE1126] text-white" : "bg-[#FFD100]"}`}>
          <Lock strokeWidth={3} className="w-4 h-4" />
          <span className="font-anton uppercase text-sm">{title}</span>
        </div>

        <h2 className="font-anton uppercase text-3xl mt-4 leading-tight">
          Pa&apos; <span className="text-[#CE1126]">{reason.toLowerCase()}</span> necesitas el pase.
        </h2>

        <p className="font-outfit text-sm text-black/70 mt-2">
          Pago único de <span className="font-bold">${price} MXN</span> con Mercado Pago. {isPremium ? "Incluye TODO: estilos premium + descargas + compartir." : "Después descargas y compartes todos los stickers que quieras, para siempre, en este dispositivo."}
        </p>

        <div className="mt-5 flex items-baseline gap-2">
          <span className="font-anton text-6xl leading-none">${price}</span>
          <span className="font-anton uppercase text-xl">MXN</span>
          <span className="font-outfit text-sm text-black/60 ml-2">pago único</span>
        </div>

        <ul className="mt-4 space-y-2">
          {features.map((b) => (
            <li key={b} className="flex items-center gap-2 font-outfit text-sm">
              <span className={`w-5 h-5 border-[2px] border-black flex items-center justify-center ${isPremium ? "bg-[#CE1126]" : "bg-[#006847]"}`}>
                <ShieldCheck strokeWidth={3} className="w-3.5 h-3.5 text-white" />
              </span>
              {b}
            </li>
          ))}
        </ul>

        <button
          data-testid="paywall-pay-btn"
          onClick={onPay}
          disabled={loading}
          className={`mt-6 w-full nb-btn font-anton uppercase text-2xl px-6 py-4 text-white border-[3px] border-black shadow-[5px_5px_0_0_#000] inline-flex items-center justify-center gap-3 disabled:opacity-70 ${isPremium ? "bg-black" : "bg-[#CE1126]"}`}
        >
          <Sparkles strokeWidth={3} />
          {loading ? "Redirigiendo…" : `Pagar $${price} con Mercado Pago`}
        </button>

        <p className="font-outfit text-xs text-black/50 mt-3 text-center">
          Pago procesado 100% por Mercado Pago. Modo de prueba activado.
        </p>
      </div>
    </div>
  );
}
